import styled from 'styled-components';
import media from '../../../../constants/media';

export const Wrapper = styled.div`
	display: flex;
	gap: 5rem;
	flex-direction: column;
	width: 100%;

	${media.tablet`
		flex-direction: row;
	`};
`;

export const Form = styled.form`
	position: relative;
	flex: 5;
	width: 100%;
`;

export const SearchInputWrapper = styled.div`
	position: relative;
	width: 100%;
	margin-top: 32px;
	margin-bottom: 16px;

	${media.tablet`
		max-width: 540px;
		margin-inline: auto
	`};
`;

export const SubmitButtonWrapper = styled.div`
	position: absolute;
	right: 8px;
	top: 8px;
`;

export const StyledSelectWrapper = styled.div`
	flex: 3;
`;
